export default {
  init() {
    // JavaScript to be fired on the about us page
    $(".js-team-member").each(function() {
        var _ = this;
        var ajaxUrl = JSON.parse($(".js-popup-options").text());
        $(_).magnificPopup({
            preloader: true,
            items: {
                type: 'inline',
                src: $('<div class="bg-white my4">' +
                    '<div class="js-popup-content">' +
                        '<div class="center fs-28 p4">' +
                            '<i class="fa fa-spin fa-spinner"></i>' +
                        '</div>' +
                    '</div>' +
                '</div>'),
            },
            callbacks: {
                beforeOpen: function() {
                    var $triggerEl = $(this.st.el),
                        newClass = $triggerEl.data("modal-class");
                        if (newClass) {
                          this.st.mainClass = this.st.mainClass + ' ' + newClass;
                        }
                },
                open: function() {
                    $.ajax({
                        url: ajaxUrl,
                        method: 'GET',
                        data: {
                            action: 'team_member_modal_html',
                            post: $(_).data('id'),
                        },
                        success: function(res) {
                            var data = res.data;
                            console.log(data);

                            $(".js-popup-content").children().remove();
                            $(".js-popup-content").append(data);
                        },
                    });
                },
            },
        });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/team.js